import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Space } from '../../Space/src/Space.js';
import '../../Typography/src/Heading.js';
import '../../Typography/src/Link.js';
import '../../Typography/src/ListItem.js';
import '../../Typography/src/OrderedList.js';
import { Text } from '../../Typography/src/Text.js';
import '../../Typography/src/UnorderedList.js';
import modules_f8db2d70 from '../styles/Content.module.less.js';
import { Step } from './Step.js';

const Content = (props) => {
    const { currentStep = 0, totalSteps, label, showLabel } = props;
    const cx = useStyles(modules_f8db2d70);
    const innerText = React.useMemo(() => {
        if (!label && !showLabel) {
            return null;
        }
        return label ?? `Шаг ${currentStep + 1} из ${totalSteps}`;
    }, [label, showLabel, currentStep, totalSteps]);
    return (React.createElement(React.Fragment, null,
        innerText && (React.createElement(Text, { size: 12, className: cx('label') }, innerText)),
        React.createElement(Space, { size: 2 }, Array.from({ length: totalSteps }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(Step, { key: `step-${index + 1}`, isActive: index === currentStep, isPassed: index < currentStep }))))));
};

export { Content };
//# sourceMappingURL=Content.js.map
